import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListProjectItemCalculationRequest extends IBaseRequest {
    id?: string;
    projectId?: string;    
}

export class ListProjectItemCalculationRequest extends BaseRequest implements IListProjectItemCalculationRequest {
    public id?: string;
    public projectId?: string;

    constructor(server: string, session: string, id?: string, projectId?: string) {
        super(server, session);
        this.id = id;
        this.projectId = projectId;
    }

    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.projectId, 'projectId');

        return super.wrapperXml('ListProjectItemCalculation', parameters);
    }
}
